import { useEffect } from 'react'

import i18n from 'utils/i18n'

export const usePageTitle = (title?: string) => {
  const pageTitle = title || i18n.t('iam.01.Common.Logo') || 'Samsung account'

  useEffect(() => {
    document.title = pageTitle
  }, [pageTitle])
}
